module.exports = __webpack_public_path__ + "static/servicing-cb492cdf24e6839e63dd50e02a2bab15.png";